import { GeoSource } from "../../types/base/Located";
import GeoAddress from "../../types/GeoAddress";

export function isPartiallyMatchedGeoAddress(
  geoAddress: GeoAddress | undefined,
  geoSource: GeoSource | null
): boolean {
  if (geoSource === GeoSource.GOOGLE && geoAddress?.partial_match) {
    return true;
  } else if (
    geoSource === GeoSource.APPLE &&
    geoAddress?.geocodeAccuracy?.toLowerCase() === "unknown"
  ) {
    return true;
  }

  return false;
}
